export default {
  complex: {
    avg_price_sqm: 'Средняя цена за м²',
    min_price: 'Минимальная цена',
    max_price: 'Максимальная цена',
    expected_delivery: 'Ожидаемая сдача',
    construction_start: 'Начало строительства',
    construction_end: 'Окончание строительства',
    sales_start: 'Начало продаж',
    distance_to_sea: 'Расстояние до моря',
    distance_to_center: 'Расстояние до центра',
    distance_to_airport: 'Расстояние до аэропорта',
    roi: 'Прогноз ROI',
    amenities: 'Удобства',
    yes: 'Да',
    no: 'Нет',
    infrastructure: 'Инфраструктура',
    nearby: 'Рядом',
    gallery: 'Галерея',
    video: 'Видео',

    // уже добавленные ключи
    total: 'Всего юнитов',
    available: 'Доступно',
    buildings: 'Здания',
    floors_short: 'эт.',
    cover_alt: 'Обложка жилого комплекса',

    // 🔹 новые ключи для работы компонента
    details: {
      developer: 'Застройщик',
      location: 'Локация',
      country: 'Страна',
      region: 'Регион',
      city: 'Город',
      district: 'Район',
      characteristics: 'Характеристики',
      class: 'Класс',
      buildings_count: 'Количество зданий',
      construction_start: 'Начало строительства',
      sales_start: 'Начало продаж',
      construction_end: 'Окончание строительства',
      delivery: 'Сдача',
      investments_prices: 'Инвестиции и цены',
      total_value_available: 'Общая стоимость доступных квартир',
      price_from: 'Цена от',
      price_to: 'Цена до',
      price_per_sqm: 'Цена за м²',
      roi: 'Прогноз ROI',
      amenities: 'Удобства',
      infrastructure: 'Инфраструктура',
      description: 'Описание',
      distances: 'Расстояния',
      to_sea: 'До моря',
      to_center: 'До центра',
      to_airport: 'До аэропорта'
    },

    // Примерные ключи для удобств
    amenities: {
      pool: 'Бассейн',
      parking: 'Паркинг',
      gym: 'Тренажёрный зал',
      security: 'Охрана'
      // сюда можно добавить все, что есть в бэке
    },

    // Примерные ключи для инфраструктуры
    infrastructure: {
      school: 'Школа',
      kindergarten: 'Детский сад',
      supermarket: 'Супермаркет',
      hospital: 'Больница'
      // сюда можно добавить все, что есть в бэке
    },

    properties_in_complex: 'Квартиры в этом комплексе',
    description: 'Описание'
  },
  residential_class: {
    complex: {
      class: 'Класс'
    }
  },
  loading: 'Загрузка...'
}
